
export default function Footer() {
    return(
        <div style={{height: '60px'}}>
        </div>
    )
}